import { Component, EventEmitter, OnInit, OnDestroy, ViewChild, ViewChildren, QueryList, Input, AfterViewInit, ComponentFactoryResolver } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { SortableOptions } from 'sortablejs';
import { ToastrService } from 'ngx-toastr';
//import { TreeviewI18n, TreeviewItem, TreeviewConfig, DropdownTreeviewComponent, TreeviewHelper, TreeviewSelection, DefaultTreeviewI18n } from 'ngx-treeview';

import { WidgetType, DashboardSelection, WidgetSelection } from 'src/app/models/dashboard';
import { Dashboard, DashboardColumn, PeriodSelectOption, Widget, SiteType, PublishedDashboard } from 'src/api/models';
import { WidgetComponent} from 'src/app/views/dashboard/widgets/widget/widget.component';
import { BaseEvent} from 'src/api/models/base-event';

import { StorageTablesService } from 'src/service/storage-tables.service';
import { DashboardTableService } from 'src/service/dashboard.service';
import { DataService } from 'src/api/services';
import { WidgetService } from 'src/service/widget.service';
import { DashboardService } from 'src/api/services/dashboard.service';
import { PublishedDashboardService } from 'src/api/services/published-dashboard.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { AbstractDataService } from 'src/service/data.service';
import { ApplicationConfigService } from 'src/service/application-config.service';

import * as signalR from '@microsoft/signalr';
import { throwIfEmpty } from 'rxjs';

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren(WidgetComponent) private widgets: QueryList<WidgetComponent>;
  @ViewChild("dashboardModal", { static: false }) dashboardModal: ModalDirective;
  @ViewChild("embeddedDashboard", { static: false }) embeddedDashboard: DashboardComponent;
  @ViewChild("widgetModal", { static: false }) widgetModal: ModalDirective;
  @ViewChildren("embeddedWidget") embeddedWidgets: QueryList<WidgetComponent>;
  embeddedWidget: WidgetComponent;





  @Input() delayLoad: boolean = false;
  loaded: boolean;

  @Input() dashboardId: number;
  @Input() dashboardIdentifier: string;

  _siteUri: string;
  @Input() set siteUri(id: string) {
    if (this._siteUri != id){
      this._siteUri = id;
      this.loadWidgets();
    }
    this._siteUri = id;
  };
  get siteUri(): string {
    return this._siteUri;
  }

  @Input() showEditor: boolean = true;
  @Input() showBanner: boolean = true;





  isModalShown: boolean = false;

  activePeriod: PeriodSelectOption;

  dashboard: Dashboard;
  fullWidget: WidgetSelection;
  embedUrl: SafeResourceUrl;
  uri: string;

  siteType: SiteType;
  siteTypes: SiteType[];
  newWidgets: Widget[];
  widgetTypes: WidgetType[];
  newWidgetType: string;
  editWidget: Widget;

  sortableSourceOptions: SortableOptions;
  sortableDisplayOptions: SortableOptions;

  isDashboardNew: boolean = false;
  rightSidebar: boolean = false;
  isEditEnabled: boolean = false;
  loading: boolean = true;
  permissionDenied: boolean = false;
  notFound: boolean = false;

  /*public treeViewConfig = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: true,
    maxHeight: 400,
  });*/

  //custom column width options
  col1WidthOptions: number[] = [];
  col2WidthOptions: number[] = [];
  col3WidthOptions: number[] = [];

  ///

  public: boolean = true;
  embed: boolean = true;
  publishCode: string;
  publicUrl: string;

  public connection: signalR.HubConnection;

  timeZones:any[];
  
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private storageTableService: StorageTablesService,
    private dataService: DataService,
    private liveData: AbstractDataService,
    private widgetService: WidgetService,
    public authService: AzureAuthService,
    private dashboardService: DashboardService,
    private publishedService: PublishedDashboardService,
    private service: DashboardTableService,
    private route: ActivatedRoute,
    private router: Router,
    private toasterService: ToastrService,
    private sanitizer: DomSanitizer,
    public app: ApplicationConfigService
  ) {
   
  }

  ngOnDestroy(): void {
    if (this.connection){
      try {
        this.liveData.clear();
        this.connection.stop();
      }
      catch {

      }
    }
  }

  public reload(dashboardSelection:DashboardSelection){
    this.dashboardId = dashboardSelection.dashboardId;
    this.dashboardIdentifier = dashboardSelection.dashboardIdentifier;
    this.uri = dashboardSelection.siteUri;
    this.siteUri = dashboardSelection.siteUri;
    if (this.dashboardIdentifier){
      this.getDashboardByIdentifier(this.dashboardIdentifier, this.siteUri);
    }else{
      this.getDashboardById(this.dashboardId.toString(), this.loadWidgets);
    }
  }

  loadWidgets(){
    if (this && this.widgets){
      for (let widget of this.widgets){
        (widget as WidgetComponent).loadData();
      }
    }
  }

  public clear(){
    this.dashboard = null;
  }

  ngOnInit(): void {
    // Watch DashboardID parameter route change
    if (this.delayLoad){
      this.embed = true;
      this.public = false;
      this.showBanner = false;
      this.loading = false;
    }
    else{
      this.route.data.subscribe(data => {
        this.public = data["public"] == true;
        this.embed = data["embed"] == true;
        if (this.public){
          this.authService.forceAnonymous();
        }
      });
      if (this.dashboardId){
        // Find existing By ID
        this.getDashboardById(this.dashboardId.toString(), null);
      } else if (this.dashboardIdentifier){
        this.getDashboardByIdentifier(this.dashboardIdentifier, null);
      } else {
        this.route.queryParams.subscribe(params => {
          const theme = params["theme"];          
          if (theme){
            this.app.setTheme(theme);
          }
        });
        this.route.params.subscribe(params => {
          const dashboardParam: string = params["dashboardId"];
          const identifier = params["identifier"];
          
          if (this.public && identifier){
            // we have a published dashboards
            this.getDashboardByIdentifier(identifier, this.siteUri);
          }else{
            const dashboardId = params["dashboardId"];
            this.uri = params["uri"];
            this.siteUri = params["uri"];
            
            if (!isNaN(dashboardId)) {
              // Find existing By ID
              this.isDashboardNew = false;
              this.getDashboardById(dashboardId, null);
            } else if (dashboardParam.toLowerCase() === "new") {
              // Create New
              this.isDashboardNew = true;
              this.createDashboard();
            } else {
              // Redirect home
              //this.toasterService.error("Failed To Find Dashboard", "Dashboard");
              //this.router.navigate(["/"]);
              this.isDashboardNew = false;
              this.getDashboardById(dashboardId, null);
            }
            
            this.rightSidebar = this.isEditEnabled = this.isDashboardNew;
          }
        });
      }


    }

    // Build array of widgets
    this.widgetTypes = this.widgetService.getWidgets();
    this.newWidgets = [];
    for (let wt of this.widgetTypes) {
      if (!wt.admin || this.authService.isAdmin()){
        this.newWidgets.push(wt.blank as Widget);
      }
    }

    // Sortable settings
    this.updateSortableOptions();
  }

  public ngAfterViewInit(): void
  {      
      this.embeddedWidgets.changes.subscribe((comps: QueryList <WidgetComponent>) =>
      {
          this.embeddedWidget = comps.first;
          if (this.embeddedWidget) {
            this.widgetSelectedLoaded();
          }
      }); 

      
  }

  makeFavourite(){
    this.dashboardService.DashboardMakeFavourite(this.dashboard.dashboardId).subscribe(d => {
      this.dashboard.isFavourite = d;
    })
  }

  createDashboard(): void {
    const dashboard: Dashboard = {
      dashboardId: 0,
      columns: [{ widgets: [] }, { widgets: [] }, { widgets: [] }],
      name: "",
      published: false
    } as Dashboard;
    
    this.dashboard = dashboard;
  }

  exportDashboard() {
    const data = JSON.stringify(this.dashboard);
    let blob = new Blob(['\ufeff' + data], { type: 'application/json;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", this.dashboard.name + ".json");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  importDashboard(files){
    if (confirm("Do you really want to overwrite this dashboard?")){
      if(!window.FileReader) return; // Browser is not compatible

      var reader = new FileReader();
      var setDash = (d) => {
        d.customerId = this.dashboard.customerId;
        d.dashboardId = this.dashboard.dashboardId;
        d.name = this.dashboard.name;
        this.dashboard = d;
      };
      reader.onload = function(evt) {
        if(evt.target.readyState != 2) return;
        if(evt.target.error) {
            alert('Error while reading file');
            return;
        }

        const filecontent = evt.target.result;
        
        setDash(JSON.parse(filecontent.toString()) as Dashboard);
      };
  
      reader.readAsText(files[0]);
    }
  }

  removeHtml(html){
    return html?.replace(/<[^>]*>/g, ' ');
  }

  newPublication: PublishedDashboard = {} as PublishedDashboard;
  publications: PublishedDashboard[];
  publicationsLoading: boolean = true;
  showDashboardSettings(){
    this.publicationsLoading = true;
    //this.dropdownTreeviewComponent.buttonLabel = this.dashboard.timeZone ?? "NOT SET";
    if (this.authService.isAdmin){
      this.publishedService.PublishedDashboardGetPublications({
        dashboardId:this.dashboard.dashboardId, 
        customerId:this.dashboard.customerId,
        siteUri: this.siteUri }).subscribe(res => {
        this.publications = res;
        this.publicationsLoading = false;
      });
    }
  }

  addPublication(){
    this.publishedService.PublishedDashboardPublish({
      validToo: this.newPublication.linkValidToo,
      siteUri: this.siteUri,
      publishedToEmail: this.newPublication.emailAddress,
      dashboardId: this.dashboard.dashboardId,
      customerId: this.dashboard.customerId
    }).subscribe(res => {
      this.toasterService.success("Publication Added");
      if (this.publications == null){
        this.publications = [];
      }
      this.publications.push(res);
    }, err => {
      this.toasterService.error("Publication Failed")
    });
  }

  deletePublication(p){
    this.publishedService.PublishedDashboardUnPublish({publishedDashboardId: p.publishedDashboardId, customerId: p.customerId})
      .subscribe(s => {
        this.toasterService.success("Removed Publication");
        
        const index = this.publications.indexOf(p);
        this.publications.splice(index, 1);
      }, e => {
        this.toasterService.error("Failed to remove Publication")
      });
  }

  getDashboardById(id: string, onLoadComplete: any): void {
    this.loading = true;
    this.service.getDashboard(id, this.public)
      .subscribe(
        res => {
          if (res) {
            this.loading = false;
            this.permissionDenied = false;
            this.notFound = false;
            this.dashboard = res;
            // update the current customer to the dashboard customer
            // only do this if we are on the dashboard page, not when its embedded on another page.
            
            if (this.showEditor){
              this.app.setCustomerId(this.dashboard.customerId);
            }
            
            if (this.public && !this.authService.isAuthenticated()){
              if (this.dashboard.customerName) this.app.applicationName = this.dashboard.customerName;
              if (this.dashboard.customerLogoUrl) this.app.logoUrl = 'url(' + this.dashboard.customerLogoUrl + ')';
              if (this.dashboard.customerBackgroundImageUrl) this.app.backgroundImageUrl = 'url(' + this.dashboard.customerBackgroundImageUrl + ')';
              this.app.setStyles();
            }
            if (this.dashboard.periodSelect){
              this.activePeriod = this.dashboard.periodSelect.find(p => p.period == this.dashboard.period); 
              if (this.activePeriod == null){
                this.activePeriod = this.dashboard.periodSelect[0];
              }
            }
            if (this.activePeriod == null){
              this.activePeriod = {name:"", period: this.dashboard.period};
            }
            // Cache all storage table meta rows for use in editors
            if (this.dashboard.embedded) {
              this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dashboard.embedUrl);
            }
            if (this.authService.isLoggedIn){
              //this.storageTableService.getAllRows(this.dashboard.customerId, null);
              this.dataService.DataGetSiteTypes(this.dashboard.customerId).subscribe(st => {
                this.siteTypes = st;
                if (this.dashboard.siteType){
                  this.siteType = this.siteTypes.find(st => st.siteTypeCode == this.dashboard.siteType)
                }
              });
            }
            this.generatePublishedCode(); 

            this.timeZones = [];
            for (let zone of this.app.getAllTimeZones()){
              const checked = (zone == this.dashboard.timeZone);
              //const item = new TreeviewItem({ text: zone, value: zone, checked: checked });
              this.timeZones.push(zone)
            }
            
            // register for SignalR data feeds
            if (this.dashboard.liveData){
              this.subscribeLiveData(this.dashboard.signalRTarget);
            }

            if(this.dashboard.layout == 'Custom')
              {
                this.col1WidthOptions = this.generateColumnChoices(1,10);
                this.updateColumnOptions();
              }

          } else {
            this.toasterService.error("Failed To Find Dashboard", "Dashboard");
            this.loading = false;
            if (this.public){
              console.log("Permission Denied");
              this.permissionDenied = true;
            }else{
              //this.router.navigate(["/"]);
              this.notFound = true;
            }
          }
          if (onLoadComplete){
            onLoadComplete();
          }
        },
        err => {
          console.error("ERROR: getDashboardById", err);
          this.loading = false;
          this.toasterService.error("Failed To Find Dashboard", "Dashboard");
          if (this.public){
            console.log("Permission Denied");
            this.permissionDenied = true;
          }else{
            //this.router.navigate(["/"]);
            this.notFound = true;
          }
        }
      )
  }

  getDashboardByIdentifier(identifier: string, siteUri: string): void {
    this.loading = true;
    // not site specific
    this.service.getPublication(identifier, true)
      .subscribe(
        res => {
          if (res) {
            this.loading = false;
            this.permissionDenied = false;
            this.siteUri = res.siteUri ?? siteUri;
            this.dashboard = res as any;            
            this.dashboard.publishedIdentifier = identifier;
            if (this.public && !this.authService.isAuthenticated()){
              if (this.dashboard.customerName) this.app.applicationName = this.dashboard.customerName;
              if (this.dashboard.customerLogoUrl) this.app.logoUrl = 'url(  ' + this.dashboard.customerLogoUrl + ')';
              if (this.dashboard.customerBackgroundImageUrl) this.app.backgroundImageUrl = 'url(' + this.dashboard.customerBackgroundImageUrl + ')';
              this.app.setStyles();
            }
            if (this.dashboard.periodSelect){
              this.activePeriod = this.dashboard.periodSelect.find(p => p.period == this.dashboard.period); 
              if (this.activePeriod == null){
                this.activePeriod = this.dashboard.periodSelect[0];
              }
            }
            if (this.activePeriod == null){
              this.activePeriod = {name:"", period: this.dashboard.period};
            }
            // Cache all storage table meta rows for use in editors
            if (this.dashboard.embedded) {
              this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dashboard.embedUrl);
            }
            if (this.authService.isLoggedIn && !this.public){
              this.storageTableService.getAllRows(this.dashboard.customerId, null);
              this.dataService.DataGetSiteTypes(this.dashboard.customerId).subscribe(st => {
                this.siteTypes = st;
              });
            }
            this.generatePublishedCode(); 

            this.timeZones = [];
            for (let zone of this.app.getAllTimeZones()){
              const checked = (zone == this.dashboard.timeZone);
              //const item = new TreeviewItem({ text: zone, value: zone, checked: checked });
              //this.timeZones.push(item)
            }
            
            // register for SignalR data feeds
            if (this.dashboard.liveData){
              this.subscribeLiveData(this.dashboard.signalRTarget);
            }

            if(this.dashboard.layout == 'Custom')
            {
              this.col1WidthOptions = this.generateColumnChoices(1,10);
              this.updateColumnOptions();
            }

          } else {
            this.toasterService.error("Failed To Find Dashboard", "Dashboard");
            this.loading = false;
            if (this.public){
              console.log("Permission Denied");
              this.permissionDenied = true;
            }else{
              //this.router.navigate(["/"]);
            }
          }
        },
        err => {
          console.error("ERROR: getDashboardById", err);
          this.loading = false;
          this.toasterService.error("Failed To Find Dashboard", "Dashboard");
          if (this.public){
            console.log("Permission Denied");
            this.permissionDenied = true;
          }else{
            this.router.navigate(["/"]);
          }
        }
      );
  }

  onTimeZoneChange($event: string[]){
    const oldzone = this.dashboard.timeZone;
    const index = $event.indexOf(oldzone);
    if (index > -1 && $event.length > 1) {
      $event.splice(index, 1); // 2nd parameter means remove one item only
    }
    
    if ($event && $event.length > 0) {
      this.dashboard.timeZone = $event[0];
      console.log(this.dashboard.timeZone);
      for (let item of this.timeZones){
        if (item.value == this.dashboard.timeZone){
          item.checked = true;
        }else{
          item.checked = false;
        }
        item.correctChecked();
      }
    }
    else {
      this.dashboard.timeZone = null;
    }
    /*if (this.dropdownTreeviewComponent && this.dashboard){
      this.dropdownTreeviewComponent.buttonLabel = this.dashboard.timeZone;
    }*/
  }

  public subscribeLiveData(target){
    if (this.authService.isAuthenticated()){
      this.connection = new signalR.HubConnectionBuilder()
          .configureLogging(signalR.LogLevel.Warning)
          .withUrl(`/datahub?group=${target}`, {
              accessTokenFactory: () => this.authService.idToken
          }) //todo: get the bearer token added for the HTTPS connection
          .withAutomaticReconnect()
          .build();

      var conn = this.connection;
      var live = this.liveData;
      var dash = this;
      this.connection.start().then(function () {
        console.log('Started...' + target);
        
        //console.log('Started...' + url);
        conn.on(target.toLowerCase(), message => {
          
          if (dash.app.enableDebug){
            console.log("START SignalR Debug");
          }

          for (const [key, val] of Object.entries(message)) {
            if (dash.app.enableDebug){
              console.log(`# ${key}:`, val);
            }
            try {
              if (val instanceof String || typeof val === 'string'){
                var data = JSON.parse(val as string);
                for (const [uri, point] of Object.entries(data)) {
                  live.publishData(uri, point);
                  if (dash.app.enableDebug){
                    console.log(`## ${uri}:`, point);
                  }
                } 
              } else {
                live.publishValue(key, val);
              }
            }
            catch (e){
              console.error("Failed to update widget", e)
            }
          }

          if (dash.app.enableDebug){
            console.log("END SignalR Debug");
            dash.app.enableDebug = false;
          }
        });

      }).catch(function (error) {
        console.error(error);
      });
    }    
  }

  onSiteTypeChange(){
    if (this.dashboard.tagValue == ""){
      this.dashboard.tagName = null;
    }else{
      this.dashboard.tagName = "siteType";
    }
  }

  selectLayout(layout){
    this.dashboard.layout = layout;

    if (layout == 'Custom') {
      if (this.dashboard.columns) {
        if (!this.dashboard.columns[0].width) {
          this.dashboard.columns[0].width = 4;
        }
        if (!this.dashboard.columns[1].width) {
          this.dashboard.columns[1].width = 4;
        }
        if (!this.dashboard.columns[2].width) {
          this.dashboard.columns[2].width = 4;
        }
      }
      this.col1WidthOptions = this.generateColumnChoices(1,10);
      this.updateColumnOptions();
    }
  }

  addDashboard(): void {
    if (!this.isDashboardNew) {
      this.saveDashboard();
      return;
    }

    if (!this.dashboard.name) {
      this.toasterService.error("Dashboard Requires Name", "Add Dashboard");
      return;
    }

    this.dashboardService.DashboardAddDashboard(this.dashboard)
      .subscribe(
        res => {
          this.dashboard = res;
          this.isDashboardNew = false;
          this.toasterService.success("Successfully Added New Dashboard", "Add Dashboard");
          this.router.navigate(["/dashboard", res.dashboardId]);
        },
        err => {
          console.error("ERROR: addDashboard", err);
          this.toasterService.error("Failed to Add Dashboard", "Add Dashboard");
          this.router.navigate(["/"]);
        }
      )
  }

  setEmbedded(newState: boolean) {
    this.dashboard.embedded = newState;
  }

  saveDashboard(): void {
    console.log(this.dashboard);
    if (!this.dashboard.name) {
      this.toasterService.error("Dashboard Requires Name", "Save Dashboard");
      return;
    }
    this.dashboardService.DashboardUpdateDashboard(this.dashboard)
      .subscribe(
        res => {
          // don't update the object as it will change what you are editing
          this.dashboard.dashboardId = res.dashboardId;
          this.toasterService.success("Dashboard Successfully Saved", "Save Dashboard");
        },
        err => {
          console.error("Error: saveDashboard", err);
          this.toasterService.error("Failed to Save Dashboard", "Save Dashboard");
        }
      );
  }

  public generatePublishedCode(){
    var url = document.baseURI;
    var ext = "";
    if (this.dashboard.siteType){
      if (this.uri){
        ext =  `/${this.uri}`;
      }else{
        ext =  `/{replace-me}`;
      }
    }
    var html = `<iframe src="${url}#/embed/dashboard/${this.dashboard.publishedIdentifier}${ext}"></iframe>`;
    this.publishCode = html;
    this.publicUrl = `${url}#/public/dashboard/${this.dashboard.publishedIdentifier}${ext}`;
  }

  public generatePublishedUrl(code: string) : string {
    var url = document.baseURI;
    return `${url}#/publication/${code}`;
  }

  public publishToPublicDashboard(){
    if (confirm("Are you sure you want to publish this dashboard to the public? This will mean all datasets are publically accessible through this dashboard.")){
      this.dashboardService.DashboardPublishToPublic({customerId: this.app.customerId, dashboardId: this.dashboard.dashboardId})
      .subscribe(
        res => {
          this.dashboard.publishedToPublic = true;
          this.dashboard.publishedIdentifier = res.publishedIdentifier;
          this.generatePublishedCode();
          // don't update the object as it will change what you are editing
          this.toasterService.success("Dashboard Published to Public", "");
        },
        err => {
          console.error("Error: saveDashboard", err);
          this.toasterService.error("Failed to Publish Dashboard", "");
        }
      );
    }
  }

  public unPublishToPublicDashboard(){
    if (confirm("Are you sure you want to unpublish this dashboard to the public? Any public users will no longer be able to access this dashboard.")){
      this.dashboardService.DashboardUnPublishToPublic({customerId: this.app.customerId, dashboardId: this.dashboard.dashboardId})
      .subscribe(
        res => {
          this.dashboard.publishedToPublic = false;
          // don't update the object as it will change what you are editing
          this.toasterService.success("Dashboard Unpublished to Public", "");
        },
        err => {
          console.error("Error: saveDashboard", err);
          this.toasterService.error("Failed to Unpublish Dashboard", "");
        }
      );
    }
  }

  public publishToGlobalDashboard(){
    if (confirm("Are you sure you want to publish this dashboard to the all customers?")){
      this.dashboardService.DashboardPublishToGlobal({customerId: this.app.customerId, dashboardId: this.dashboard.dashboardId})
      .subscribe(
        res => {
          this.dashboard.global = true;
          // don't update the object as it will change what you are editing
          this.toasterService.success("Dashboard Published to Public", "");
        },
        err => {
          console.error("Error: saveDashboard", err);
          this.toasterService.error("Failed to Publish Dashboard", "");
        }
      );
    }
  }

  public unPublishToGlobalDashboard(){
    if (confirm("Are you sure you want to unpublish this dashboard to all customers?")){
      this.dashboardService.DashboardUnPublishToGlobal({customerId: this.app.customerId, dashboardId: this.dashboard.dashboardId})
      .subscribe(
        res => {
          this.dashboard.global = false;
          // don't update the object as it will change what you are editing
          this.toasterService.success("Dashboard Unpublished to Public", "");
        },
        err => {
          console.error("Error: saveDashboard", err);
          this.toasterService.error("Failed to Unpublish Dashboard", "");
        }
      );
    }
  }

  public archiveDashboard(){
    console.log("archiveDashboard",this.dashboard);  
    if (confirm("Are you sure you want to archive this dashboard? It will no longer by available in the Dashboard search list.")){
      this.dashboardService.DashboardArchiveDashboard({customerId: this.app.customerId, dashboardId: this.dashboard.dashboardId})
      .subscribe(
        res => {
          this.dashboard.global = true;
          // don't update the object as it will change what you are editing
          this.toasterService.success("Dashboard Archived", "");
          this.router.navigate(["/dashboards"]);
        },
        err => {
          console.error("Error: saveDashboard", err);
          this.toasterService.error("Failed to Archive Dashboard", "");
        }
      );
    }
  }

  public unArchiveDashboard(){
    if (confirm("Are you sure you want to unarchive this dashboard?")){
      this.dashboardService.DashboardUnArchiveDashboard({customerId: this.app.customerId, dashboardId: this.dashboard.dashboardId})
      .subscribe(
        res => {
          this.dashboard.global = false;
          // don't update the object as it will change what you are editing
          this.toasterService.success("Dashboard UnArchived", "");
        },
        err => {
          console.error("Error: saveDashboard", err);
          this.toasterService.error("Failed to Unarchive Dashboard", "");
        }
      );
    }
  }

  deleteDashboard(): void {
    if (confirm("Are you sure you want to delete?")) {
      this.dashboardService.DashboardRemoveDashboard(this.dashboard)
        .subscribe(
          res => {
            this.toasterService.success("Dashboard Successfully Deleted", "Delete Dashboard");
            this.router.navigate(["/dashboards"]);
          },
          err => {
            console.error("ERROR: deletDashboard", err);
            this.toasterService.error("Failed to Delete Dashboard", "Delete Dashboard");
          }
        )
    }
  }

  toggleSideMenu() {
    this.rightSidebar = !this.rightSidebar;
  }

  showColumn(column: DashboardColumn): boolean {
    // can show column if it has any widgets
    return column && column.widgets && column.widgets.length > 0;
  }

  getColumnClass(column: DashboardColumn): string {
    if (this.dashboard.layout == "Standard"){
      var index = this.dashboard.columns.indexOf(column);
      var filtered = this.dashboard.columns.filter((item) =>
        this.showColumn(item)
      );
      if (filtered.length === 3 || this.isEditEnabled) {
        if (index === 0) return "col-xl-2 col-lg-2 col-md-3";
        if (index === 1) return "col-xl-8 col-lg-8 col-md-6";
        return "col-xl-2 col-lg-2 col-md-3";
      }
      if (filtered.length === 1) {
        return "col-lg-12";
      }
      if (filtered.length === 2) {
        // which one is missing?
        var indexes = [];
        for (let f of filtered) {
          indexes.push(this.dashboard.columns.indexOf(f));
        }
        if (indexes.indexOf(1) >= 0) {
          if (index === 0) return "col-xl-2 col-lg-3 col-md-4";
          if (index === 1) return "col-xl-10 col-lg-9 col-md-8";
          return "col-xl-2 col-lg-2 col-md-4";
        } else {
          if (index === 0) return "col-lg-6";
          if (index === 1) return "col-lg-9";
          return "col-lg-6";
        }
      }

      return "";
    } else if (this.dashboard.layout == "Even") {
      var index = this.dashboard.columns.indexOf(column);
      var filtered = this.dashboard.columns.filter((item) =>
        this.showColumn(item)
      );
      if (filtered.length === 3 || this.isEditEnabled) {
        return "col-xl-4 col-lg-4 col-md-4";
      }
      if (filtered.length === 1) {
        return "col-lg-12";
      }
      if (filtered.length === 2) {
        // which one is missing?
        var indexes = [];
        for (let f of filtered) {
          indexes.push(this.dashboard.columns.indexOf(f));
        }
        if (indexes.indexOf(1) >= 0) {
          return "col-xl-6 col-lg-6 col-md-6";
        } else {
          return "col-lg-6";
        }
      }

      return "";
    }

    else if (this.dashboard.layout == "Custom")
    {
      const index = this.dashboard.columns.indexOf(column);
      const filtered = this.dashboard.columns.filter((item) =>
        this.showColumn(item)
      );

      if (filtered.length === 3 || this.isEditEnabled) {
        return "col-md-" + this.dashboard.columns[index].width;
      }
      else if (filtered.length === 1) {
        return "col-lg-12";
      }
      else if (filtered.length == 2)
      {
        const indexes = [];
        for (let f of filtered) {
          indexes.push(this.dashboard.columns.indexOf(f));
        }

        const notInFilteredIndex = this.dashboard.columns.findIndex((item) => !filtered.includes(item));
        if (index == notInFilteredIndex)
        {
          return "d-none";
        }

        let values = indexes.map (i => this.dashboard.columns[i].width);
        values = this.maximizeColumnSize(values);

        return "col-md-" + values[index];
      }
    }
    return "";
  }

  //helpers for custom column sizes to make bootstrap classes line up
  maximizeColumnSize(values)
  {
    if (values.length != 2)
    {
      console.error("this should only take 2 columns")
    }
    if (values[0] == values[1])
    {
      values = [6,6]
      return values
    }

    while (values[0] + values[1] <12)
    {
      if (values[0] + values[1] > 12) { return [6, 6] };
      let difference = 12 - values[0] - values[1];
      if (difference>1)
      {
        values[0] +=1;
        values[1] +=1;
      }

      else if (values[0] > values[1])
      {
        values[0] += 1;
      }
      else
      {
        values[1] +=1;
      }

    }
    return values;
  }

  generateColumnChoices(min: number, max: number): number[] {
    const options = [];
    for (let i = min; i <= max; i++) {
      options.push(i);
    }
    return options;
  }

  updateColumnOptions() {
    if (this.dashboard.layout !== 'Custom') return;
    if (this.dashboard.columns.length !== 3) return;
  
    // Column 2
    const remainingForCol2 = 12 - this.dashboard.columns[0].width - 1;
    const col2max = Math.min(10, remainingForCol2);
    this.col2WidthOptions = this.generateColumnChoices(1, col2max);
  
    if (this.dashboard.columns[1].width > col2max) {
      this.dashboard.columns[1].width = col2max;
    }
  
    // Column 3
    const remainingForCol3 = 12 - this.dashboard.columns[0].width - this.dashboard.columns[1].width;
    this.dashboard.columns[2].width = remainingForCol3;
    this.col3WidthOptions = this.generateColumnChoices(1, remainingForCol3);
  }
  //-----------

  public showModal(): void {
    this.isModalShown = true;
  }

  public hideModal(): void {
    this.dashboardModal.hide();
  }

  public onHidden(): void {
    this.isModalShown = false;
  }

  removeWidget(column: DashboardColumn, widget: Widget): void {
    if (confirm("Are you sure you want to delete?")) {
      var index = column.widgets.indexOf(widget);
      if (index > -1) {
        column.widgets.splice(index, 1);
      }
    }
  }

  editWidgetSettings(widget: Widget) {
    this.newWidgetType = null;
    this.editWidget = widget;
    this.showModal();
  }

  copyWidgetSettings(e, widget: Widget) {
    var tocopy = JSON.stringify(widget);

    var textArea = document.createElement("textarea");
    textArea.value = tocopy;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";
      console.log("Fallback: Copying text command was " + msg);
    } catch (err) {
      console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
  }

  duplicateWidgetSettings(e, widget: Widget) {
    this.editWidget = JSON.parse(JSON.stringify(widget));
    // add the widget to the dashboards
    if (this.dashboard.columns == null || this.dashboard.columns.length === 0) {
      this.dashboard.columns = [
        { widgets: [] },
        { widgets: [] },
        { widgets: [] },
      ];
    }
    var column = this.dashboard.columns[1];
    if (column.widgets == null) {
      column.widgets = [];
    }
    column.widgets.push(this.editWidget);
    this.showModal();
  }

  resizeWidgets() {
    this.updateSortableOptions();

    for (let column of this.dashboard.columns) {
      for (let widget of column.widgets) {
        // widget.editMode = this.isEditEnabled;
        // todo - JAMES - editMode doesn't exist on model on the backend, but it's not required either, how best to handle this?
      }
    }
  }

  private updateSortableOptions(): void {
    // Updating sortable options requires new options objects to be made, deep changes are not detected
    this.sortableSourceOptions = {
      group: {
        name: 'shared',
        pull: 'clone',
        put: false,
        revertClone: true,
      },
      sort: false,
      animation: 150,
      onClone: evt => {
        //console.log(evt.clone);
        //evt.clone.setData
        /*this.widgetTypes = this.widgetService.getWidgets();
        //this.newWidgets = [];
        console.log(this.widgetTypes);
        var i = 1;
        for (let wt of this.widgetTypes) {
          // new clone of widget config over top of old one.
          this.newWidgets[i] = wt.blank as Widget;
          i++;
        }*/
      }
    };

    this.sortableDisplayOptions = {
      group: {
        name: 'shared',
        //pull: 'clone',
        put: true,
        //revertClone: true,
      },
      disabled: !this.isEditEnabled,
      delayOnTouchOnly: true,
      delay: 5000,
      animation: 150,
      swapThreshold: 0.9,
      /*onClone: function (evt){
        console.log("Destination Clone", evt);

      }*/
      onAdd: evt => {
        console.log(evt);
      }
    };
  }

  addPeriodSelect(){
    this.dashboard.periodSelect.push({period:""});
  }

  removePeriodSelect(period){
    const index = this.dashboard.periodSelect.indexOf(period, 0);
    if (index > -1) {
      this.dashboard.periodSelect.splice(index, 1);
    }
    //this.dashboard.periodSelect.
  }

  changePeriod(period){
    this.activePeriod = period;
    this.dashboard.period = this.activePeriod.period;
    // refresh all widgets
    //todo: figure this out
    console.log("Changing displayed time period");
    this.loadWidgets();
  }

  selectedDashboard: DashboardSelection;

  dashboardSelected(dashboardDetails){
    // you have to clear the selectedDashboard first to make angular refresh the component
    this.selectedDashboard = null;
    this.selectedDashboard = dashboardDetails;
    if (this.selectedDashboard){
      this.embeddedDashboard?.clear();
      this.dashboardModal.show();
      this.embeddedDashboard.reload(this.selectedDashboard);
    }
  }

  widgetSelected(widgetDetails: WidgetSelection){
    // you have to clear the fullWidget first to make angular refresh the component
    this.fullWidget = null;
    this.fullWidget = widgetDetails;
    if (this.fullWidget){
      this.widgetModal.show();
      this.embeddedWidget?.clear();
      //this.embeddedWidget.reload(widgetDetails);
    }
  }

  widgetSelectedLoaded(){
    this.embeddedWidget?.reload(this.fullWidget);
  }



}
